import { AssetSearchInput, FilterType } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { AddButton } from '../../shared/components/addButton/addButton';
import { FilterBar } from '../../shared/components/filter/filterBar';
import { ModalButton } from '../../shared/components/modalButton';
import { NewAssetModal } from './newAssetModal';

export const AssetsFiltersOld = () => {
  return (
    <View style={styles.filtersContainer}>
      <View style={styles.assetSearchContainer}>
        <AssetSearchInput />
      </View>
      <FilterBar
        filterButtonTypes={[
          FilterType.ASSETGROUPS,
          FilterType.ASSETCOLUMNS
        ]}
      />
      {
        <ModalButton
          label=""
          customButton={(toggleVisibility) => (
            <AddButton onPress={() => toggleVisibility(true)} />
          )}
          modalComponent={({ onComplete }) => {
            return (
              <NewAssetModal 
                closeModal={onComplete} 
              />
            );
          }}
          containerStyle={styles.modal}
        />
      }
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  assetSearchContainer: {
    width: 300, // current minimum size needed to avoid placeholder clipping on web
    marginRight: 20,
  },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
